import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';

export interface CheckinLogRow {
  id: string;
  createdAt: string;
  userDisplayName: string;
  fanCardCode: string;
  matchLabel: string;
  matchDate: string | null;
  isGeoValid: boolean;
  clientMockedGps: boolean;
  pointsAwarded: number;
}

export interface MatchQrDto {
  matchId: string;
  qrPayload: string;
  qrMode: 'permanent' | 'per_match';
  matchName: string;
  matchDate: string;
}

const QK_LOG = ['checkin-admin-log'] as const;

export function useCheckinLog(limit = 50) {
  return useQuery({
    queryKey: [...QK_LOG, limit],
    queryFn: async () => {
      const res = await apiClient.get<CheckinLogRow[]>('/checkin/admin/log', {
        params: { limit },
      });
      return res.data;
    },
  });
}

export function useMatchQr(matchId: string | null) {
  return useQuery({
    queryKey: ['checkin-match-qr', matchId],
    enabled: !!matchId,
    queryFn: async () => {
      const res = await apiClient.get<MatchQrDto>(`/checkin/match/${matchId}/qr`);
      return res.data;
    },
  });
}

export function useGenerateMatchQr() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (matchId: string) => {
      const res = await apiClient.get<MatchQrDto>(`/checkin/match/${matchId}/qr`);
      return res.data;
    },
    onSuccess: (data) => {
      qc.setQueryData(['checkin-match-qr', data.matchId], data);
    },
  });
}
